import { Link } from 'react-router-dom'
import '../styles/viewblog.css'

import BlogImage from '../assets/images/BLOG-copy-2.webp'
import DSC0083 from '../assets/images/DSC0083.jpg'
import DSC0127 from '../assets/images/DSC0127-2.jpg'
import DSC_6060 from '../assets/images/DSC_6060.jpg'
import DSC_6888 from '../assets/images/DSC_6888.jpg'
import DSC_6270 from '../assets/images/DSC_6270-1536x1024.jpg'

import arrowI from '../assets/icons/arrow-right-s-line.svg'
import facebook from '../assets/icons/facebook.png'
import pinterest from '../assets/icons/pinterest.png'
import x from '../assets/icons/x.png'

import Helmet from '../components/Helmet/Helmet'
import Gc from '../components/Gc/Gc'

const BudgetLense_blog = () => {

  const items = [
    { xs: 4, imgSrc: DSC0083 },
    { xs: 4, imgSrc: DSC0127 },
    { xs: 4, imgSrc: DSC_6060 },
    { xs: 6, imgSrc: DSC_6888 },
    { xs: 6, imgSrc: DSC_6270 },
  ];


  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank');
  };

  const shareOnPinterest = () => {
    window.open(`https://www.pinterest.com/pin/create/button/?url=${window.location.href}&media=${BlogImage}`, '_blank');
  };

  const shareOnX = () => {
    window.open('https://www.x.com/share?url=' + encodeURIComponent(window.location.href), '_blank');
  };


  return <Helmet title={'Budget Lens for Macro Photography'}>
  <section className='view__blog __black'>
  <div className="w-1">
      <div className='blog__socialmedia-main'>
        <div className="blog__socialmedia-bar">
          <span>share:</span>
          <button onClick={shareOnFacebook}><img src={facebook} alt="facebook" /></button>
          <button onClick={shareOnPinterest}><img src={pinterest} alt="pinterest" /></button>
          <button onClick={shareOnX}><img src={x} alt="x" /></button>
        </div>
        <h1>Budget Lens for Macro Photography</h1>
        <span className='dash'></span>
      </div>
      <div>
          <img src={BlogImage} alt="" />
          <h1 className='view__blog-subheading'>Tokina AT-X M100 f/2.8 PRO D Macro</h1>
          <p>This is a good recommendation for beginners and also for pro’s in Macro photography. I personally love macro photography of reptiles and small insects. My first macro lense in my mind was nikon 105 f2.8 lense. But because it was too much expensive I went for this one. I bought this from Singapore for Rs. 55 000.  This is both Nikon and canon mount. And this is a FX lense. </p>
      </div>
      {/* <GalleryComponent imgStyle={{padding:'5px', height:'60vh'}} items={items} />; */}
      <Gc style={{height:'65vh'}} items={items} />
      <div className='view__blog-details'>
          <p>I was able to take so many impressive photos with this lense. So that’s why I’m saying this is worth for the price.</p>
          <p>The sharpness of this lens is very good. In general, both Nikon and Canon lenses have a good sharpness. Sharpness is better than both Sigma and Tamron lenses.</p>
          <p>This lens is lightweight and small. You can carry it even in a small space. If we use a handheld, a macro photo is worth a lot of weight because if we use a diffuser and other equipment  it will be much heavier for hands. It is difficult to stay in the same position for a while..so the low weight of this lens is very important.</p>
          <p>This lens has a slightly lower focusing speed than the Nikon and Canon lenses. This Tokina lens is a D type lens .. that means it is old .. there is no motor inside this .. therefore Auto Focus works from the motor in your body. If your body is an entry level .. that means for example a Nikon D3300 .. you will not be able to use the auto focus on this lens .. I also had a Nikon D3300 when I bought this lens so I could not use the AF in this. .But most of the time we take macro photo with manual focus. Because small animals are a little difficult to use AF..I think it will not be a big problem … If you have a good camera, AF will work for you.</p>
          <p>So I say if you find it difficult to spend a lot of macro lenses, you can get very good results with good overall quality for a small amount of money like this. I still use this lens and it is a lens that gave me good results. You can also use this to get a portrait. I used to use this lens with the Nikon D3300 Body. Now I use it with the D500 Body.</p>
      </div>
      <hr />
      <Link className='previous_blog' to='/blog'><img src={arrowI} alt="" />previous post</Link>
  </div>
</section>
</Helmet>
}

export default BudgetLense_blog